import { render, staticRenderFns } from "./DP458.vue?vue&type=template&id=3b604715&scoped=true&"
import script from "./DP458.vue?vue&type=script&lang=js&"
export * from "./DP458.vue?vue&type=script&lang=js&"
import style0 from "./DP458.vue?vue&type=style&index=0&id=3b604715&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b604715",
  null
  
)

export default component.exports